import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const About = () => {
  return (
    <div>
      <Navbar />
      
      {/* Hero */}
      <section className="pt-32 pb-20 bg-primary text-primary-foreground">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-4xl">
          <div className="text-sm font-medium tracking-[0.2em] uppercase text-accent mb-6">
            Why We Exist
          </div>
          <h1 className="text-5xl md:text-6xl font-heading font-semibold tracking-tight leading-[1.05]">
            Talent is distributed equally. Access is not.
          </h1>
        </div>
      </section>

      {/* Origin Story */}
      <section className="py-24 md:py-32 bg-background">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-6xl">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
            {/* Portrait */}
            <div className="lg:col-span-5 order-2 lg:order-1">
              <div className="relative">
                <img
                  src="https://customer-assets.emergentagent.com/job_first-gen-future/artifacts/x3iy4eiv_AndreaCnew.jpg"
                  alt="Andrea Coopersmith, J.D. — Founder of Lantern Prep"
                  data-testid="founder-portrait"
                  className="w-full h-auto object-cover grayscale-[0.05]"
                />
                <div className="absolute -bottom-3 left-0 right-0 h-px bg-accent/60"></div>
              </div>
              <div className="mt-6">
                <p className="font-heading text-2xl text-primary leading-tight">Andrea Coopersmith, J.D.</p>
                <p className="text-sm text-muted-foreground mt-2 leading-relaxed">
                  Founder · Amherst College · Harvard Law School
                </p>
              </div>
            </div>

            {/* Copy */}
            <div className="lg:col-span-7 order-1 lg:order-2">
              <div className="text-xs font-medium tracking-[0.2em] uppercase text-accent mb-6">
                Founder
              </div>
              <h2 className="text-3xl md:text-4xl font-heading font-semibold text-primary mb-10 tracking-tight leading-tight">
                Andrea Coopersmith, J.D.
              </h2>
              <div className="space-y-6 text-lg leading-relaxed text-muted-foreground">
                <p>
                  Andrea Coopersmith, a first-generation college graduate raised by her Colombian mother in a single-parent household, navigated the path to Amherst College (<em>magna cum laude</em>) and Harvard Law School without the guidance systems many families take for granted.
                </p>
                <p>
                  After law school, she worked as an advocate for students in New York's child welfare and juvenile justice systems. There, she saw a consistent pattern: talented, motivated young people held back not by ability, but by a lack of access, information, and support.
                </p>
                <p className="text-foreground font-medium">
                  Fluent in Spanish and committed to the families most underserved by existing resources, she founded Lantern Prep in St. Petersburg to ensure the guidance that changes outcomes is no longer a matter of luck.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-24 bg-muted">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-6xl">
          <h2 className="text-3xl font-heading font-semibold text-center text-primary mb-16">Our Values</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            <div>
              <h3 className="text-2xl font-heading font-medium text-primary mb-4">Expertise</h3>
              <p className="text-lg leading-relaxed text-muted-foreground">
                Preparation built on evidence, strategy, and deep understanding of the admissions landscape.
              </p>
            </div>
            <div>
              <h3 className="text-2xl font-heading font-medium text-primary mb-4">Strategy</h3>
              <p className="text-lg leading-relaxed text-muted-foreground">
                Personalized guidance that recognizes each student's unique strengths and aspirations.
              </p>
            </div>
            <div>
              <h3 className="text-2xl font-heading font-medium text-primary mb-4">Mentorship</h3>
              <p className="text-lg leading-relaxed text-muted-foreground">
                Sustained support that extends beyond test scores and applications.
              </p>
            </div>
            <div>
              <h3 className="text-2xl font-heading font-medium text-primary mb-4">Access</h3>
              <p className="text-lg leading-relaxed text-muted-foreground">
                A model where every engagement opens a seat for a student who has earned it.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Team Structure */}
      <section className="py-24 bg-background">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-4xl">
          <h2 className="text-3xl font-heading font-semibold text-primary mb-8">One Standard, Every Student</h2>
          <div className="space-y-6 text-lg leading-relaxed text-muted-foreground">
            <p>
              Andrea Coopersmith leads Lantern Prep and is personally involved in every student's plan. She works alongside a small, carefully chosen team of advisors and specialists — people whose credentials and experience the work requires.
            </p>
            <p>
              Cohort sizes are deliberately limited. Every student is known to the people guiding them, and every family knows who to call.
            </p>
          </div>
        </div>
      </section>

      {/* Geography */}
      <section className="py-24 bg-primary text-primary-foreground">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-4xl text-center">
          <h2 className="text-3xl font-heading font-semibold mb-6">Rooted in Tampa Bay</h2>
          <p className="text-lg leading-relaxed text-primary-foreground/80 max-w-2xl mx-auto">
            Based in St. Petersburg, we understand the local landscape—the schools, the scholarships, the state university system. This is where we live, and this is where we work.
          </p>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default About;